function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.485 9L2 17.485.586 16.071 7.657 9 .586 1.929 2 .515 10.485 9z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 11 18"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-chevron.e999ee24.svg";
export { SvgComponent as ReactComponent };